'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useAuthSession } from '@/providers/app-runtime';
import {
  recordClientPageView,
  startClientTelemetry,
  stopClientTelemetry,
} from '@/lib/client-telemetry';

// Mounts the app-wide client telemetry pipeline (lib/client-telemetry.ts)
// once the session is authenticated, and feeds it route changes. Must live
// inside AppRuntimeProvider for useAuthSession.
export function ClientTelemetryProvider({ children }: { children: React.ReactNode }) {
  const auth = useAuthSession();
  const pathname = usePathname();
  const active = auth.status === 'authenticated' && Boolean(auth.user);

  useEffect(() => {
    if (!active) {
      return;
    }
    startClientTelemetry();
    return () => {
      stopClientTelemetry();
    };
  }, [active]);

  useEffect(() => {
    if (active && pathname) {
      recordClientPageView(pathname);
    }
  }, [active, pathname]);

  return <>{children}</>;
}
